import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { fetchShops } from 'src/libs/api/shopApi';
import { ShopSchema } from 'src/models/shop/schema';
import { WithLastModified } from 'src/models/WithLastModified';
import useSWR from 'swr';

const useShops = (): {
  shops: ShopSchema[] | undefined;
  isShopsLoading: boolean;
  isShopsError: boolean;
} => {
  const { locale } = useRouter();
  const savedData = require(`data/${locale}/shops.json`) as WithLastModified<ShopSchema[]>;
  const fetcher = useCallback(async (key: string[]): Promise<ShopSchema[]> => {
    let lastModified;
    if (savedData) {
      lastModified = savedData.lastModified;
    }
    const shops = await fetchShops(key[1], lastModified);
    return shops.length > 0 ? shops : savedData.data;
  }, []);

  const { data, error } = useSWR(locale ? [`/api/shops`, locale] : null, fetcher, {
    errorRetryCount: 0,
    dedupingInterval: 3600, // 1時間,
    fallbackData: savedData.data,
  });

  return {
    shops: data,
    isShopsLoading: !data && !error,
    isShopsError: !!error,
  };
};

export { useShops };
